"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsLoading = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const clusterSlice_1 = __importDefault(require("./clusterSlice"));
const crowdMapSlice_1 = __importDefault(require("./crowdMapSlice"));
const exportSessionSlice_1 = __importDefault(require("./exportSessionSlice"));
const fixedSessionsSlice_1 = __importDefault(require("./fixedSessionsSlice"));
const fixedStreamSlice_1 = __importDefault(require("./fixedStreamSlice"));
const indoorSessionsSlice_1 = __importDefault(require("./indoorSessionsSlice"));
const loadingSelectors_1 = require("./loadingSelectors");
Object.defineProperty(exports, "selectIsLoading", { enumerable: true, get: function () { return loadingSelectors_1.selectIsLoading; } });
const mapSlice_1 = __importDefault(require("./mapSlice"));
const markersLoadingSlice_1 = __importDefault(require("./markersLoadingSlice"));
const mobileSessionsSlice_1 = __importDefault(require("./mobileSessionsSlice"));
const mobileStreamSlice_1 = __importDefault(require("./mobileStreamSlice"));
const movingCalendarStreamSlice_1 = __importDefault(require("./movingCalendarStreamSlice"));
const popoverSlice_1 = __importDefault(require("./popoverSlice"));
const realtimeMapUpdatesSlice_1 = __importDefault(require("./realtimeMapUpdatesSlice"));
const rectangleSlice_1 = __importDefault(require("./rectangleSlice"));
const sensorsSlice_1 = __importDefault(require("./sensorsSlice"));
const sessionFiltersSlice_1 = __importDefault(require("./sessionFiltersSlice"));
const thresholdSlice_1 = __importDefault(require("./thresholdSlice"));
const timelapseSlice_1 = __importDefault(require("./timelapseSlice"));
const store = (0, toolkit_1.configureStore)({
    reducer: {
        cluster: clusterSlice_1.default,
        crowdMap: crowdMapSlice_1.default,
        fixedSessions: fixedSessionsSlice_1.default,
        fixedStream: fixedStreamSlice_1.default,
        indoorSessions: indoorSessionsSlice_1.default,
        map: mapSlice_1.default,
        markersLoading: markersLoadingSlice_1.default,
        mobileSessions: mobileSessionsSlice_1.default,
        mobileStream: mobileStreamSlice_1.default,
        movingCalendarStream: movingCalendarStreamSlice_1.default,
        popover: popoverSlice_1.default,
        realtimeMapUpdates: realtimeMapUpdatesSlice_1.default,
        rectangle: rectangleSlice_1.default,
        sensors: sensorsSlice_1.default,
        session: exportSessionSlice_1.default,
        sessionFilter: sessionFiltersSlice_1.default,
        threshold: thresholdSlice_1.default,
        timelapse: timelapseSlice_1.default,
    },
});
exports.default = store;
